/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Header } from '@mairistem/composants';

interface SectionHeaderProps {
  title: string;
  required?: boolean;
}

const SectionHeader = (props: SectionHeaderProps) => {
  const { title, required, ...rest } = props;

  return (
    <Header as="h4" color="blue" {...rest}>
      <span style={{ textDecoration: 'underline' }}>{title}</span>
      {required && (
        <span style={{ color: '#96222a', marginLeft: '0.25em' }}>*</span>
      )}
    </Header>
  );
};

export default SectionHeader;
